/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, May 2020
 */

import EventEmitter from 'events';
import React from 'react';
import { FlowState } from '@staffino/model';
import { FlowObject, IFlowBridge } from './flow-bridge';

type FlowBridgeContextType = {
  bridge: IFlowBridge;
};

const error = new Error(
  'Flow bridge is not installed. Make sure you supply valid bridge when creating FlowContainer.',
);
class DummyBridge extends EventEmitter implements IFlowBridge {
  flowId: '';
  targetId: '';
  customerId: '';
  interactionId: '';
  assets: {};
  localeId: '';
  load(condition: Partial<FlowObject>): Promise<FlowObject[]> {
    throw error;
  }
  saveState(state: FlowState): Promise<void> {
    throw error;
  }
  commitState(state: FlowState): Promise<void> {
    throw error;
  }
  reportError(e: Error) {
    throw error;
  }
  setLocale(id: string, code: string): Promise<void> {
    throw error;
  }

  updateFlowSession(state: FlowState): Promise<void> {
    throw error;
  }
}
const FlowBridgeContext = React.createContext<FlowBridgeContextType>({
  bridge: new DummyBridge(),
});

export default FlowBridgeContext;
